module.exports = __webpack_public_path__ + "img/web1.8cef8d50.svg";